import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useEffect, useRef, useState } from "react";

//Components
import { Modal, ModalBody, ModalFooter, Button, Form, Input, ToggleSwitch } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

//Actions
import {
    searchEntityRequest,
    clearRedux,
    manufacturerCreateRequest,
    manufacturerGetRequest,
    manufacturerEditRequest,
} from 'Redux/actions';

const CreateEditManufacturer = (props) => {
    const { tableRef, getData } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const formRef = useRef();

    const [name, setName] = useState('');
    const [active, setActive] = useState(true);

    const {
        openModal,
        loading,
        create,
        update,
        manufacturer,
        current,
    } = useSelector(state => state.createEditManufacturerRedux);

    const closeModal = () => {
        setName('');
        setActive(true);
        dispatch(clearRedux("MANUFACTURER_CREATE_EDIT"))
    }

    const applyChanges = () => {
        const trimmedName = name.trim();
        if (!trimmedName) {
            NotificationManager.error(
                messages['required_field'],
                messages['manufacturer_name'],
                3000
            );
            return;
        }

        let payload = {
            name: trimmedName,
            active: active
        }
        if (current?.id) {
            payload.id = current?.id
            dispatch(manufacturerEditRequest(payload))
        } else dispatch(manufacturerCreateRequest(payload))
    }

    useEffect(() => {
        if (create?.id) {
            NotificationManager.success(
                messages['manufacturer_create_success_message'],
                messages['manufacturer_create_title'],
                3000
            );
            closeModal();
            tableRef && tableRef?.current?.getData();
            dispatch(clearRedux("MANUFACTURER_CREATE_EDIT", { create: null }))
            dispatch(searchEntityRequest({ key: "manufacturers" }));
        }

        if (update) {
            NotificationManager.success(
                messages['manufacturer_edit_success_message'],
                messages['manufacturer_edit_title'],
                3000
            );
            closeModal();
            tableRef && tableRef?.current?.getData();
            getData && getData()
            dispatch(clearRedux("MANUFACTURER_CREATE_EDIT", { update: null }))
            dispatch(searchEntityRequest({ key: "manufacturers" }));
        }

        if (manufacturer) {
            setName(manufacturer?.name);
            setActive(manufacturer?.active);
        }
    }, [create, update, current, manufacturer])

    useEffect(() => {
        if (openModal && current?.id) {
            dispatch(manufacturerGetRequest(current?.id))
        }
    }, [openModal])

    return (
        <Modal
            open={openModal}
            title={current?.id ? `${messages['manufacturer_edit_title']} (${current?.name})` : messages['manufacturer_create_title']}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div style={{ padding: '0 10px', height: 600 }}>
                    <Form
                        ref={formRef}
                        onValidSubmit={() => applyChanges()}
                    >
                        <div style={{ marginTop: 5 }}>
                            <Input
                                label={messages['manufacturer_name']}
                                placeholder={messages['manufacturer_name']}
                                value={name}
                                onChange={(value) => setName(value)}
                                maxLength={80}
                                required
                                requiredMessage={messages['required_field']}
                            />
                        </div>
                        <div style={{ textAlign: 'left', display: 'grid', padding: '10px 0px' }}>
                            <label style={{ marginBottom: 5 }} className="input-normal-label">{messages['manufacturer_status']}</label>
                            <ToggleSwitch
                                id="manufacturer-active"
                                medium
                                blueToggle
                                optionLabels={[messages['manufacturer_active'], messages['manufacturer_inactive']]}
                                checked={active}
                                onChange={setActive}
                            />
                        </div>
                    </Form>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => {
                        formRef?.current?.submit()
                    }}
                >
                    {messages['save']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default CreateEditManufacturer;